<div id="PG_ClientSelection" class="glb_formBGColor glb_boxedPadding glb_Font glb_Font">

    <!-- Close modal button. put this here on its own row, so that it stays put and won't bootstrap down to another row in smaller screen sizes -->
    <div class="glb_customFlexRow justify-content-end">
        <div class="justify-content-start glb_boxedPaddingNarrow align-self-bottom glb_PaddingVerticalZeroOffset">
            <button id="BTN_CloseClientSelection" tabindex="3"
                class="btn glb_clickableIconButtonStyleNone glb_clickableIconButtonColorDark glb_skinLightOutline" type="button"
                (click)="ClientSelection_CloseModal()">
                <fa-icon [icon]="['fal', 'times']" class="fa-md glb_modalClose"></fa-icon>
            </button>
        </div>
    </div>
    <div class="glb_Font header-padding glb_customFlexRow text-white">
        <div class="glb_customFlexRow col-12">
            <div class="glb_customFlexRow col-8 glb_paddingZeroOffset">
                <div class="col-8 glb_paddingZeroOffset">
                    <div class="glb_TitleLG glb_TitleLGMobile text-start glb_breakLongWords glb_paddingZeroOffset glb_paddingBottomSM">
                        Select a client
                    </div>
                </div>
            </div>
        </div>
        <div class="text-white glb_customFlexRow row-cols-1 justify-content-left glb_paddingBottomSM col-12">
            <!-- <div class="text-white glb_inputFieldLabel glb_customFlexRow">Choose Client</div> -->
            <div class="glb_customFlexRow row-cols-1 col-12 glb_paddingZeroOffset justify-content-left text-dark">
                <div class="glb_paddingZeroOffset col-10 col-lg-6">
                    <!-- This is a primeng multiselect for choosing a target client-->
                    <p-multiSelect class="col-12" #INP_MultiselectSingle id="DU_MultiselectSingle" [options]="ClientMultiselectOptions"
                        [(ngModel)]="SelectedMultiselectSingleOptions" optionLabel="name" [appendTo]="'body'" [filter]="true" [virtualScroll]="true"
                        [virtualScrollItemSize]="40" [resetFilterOnHide]="true" [selectAll]="false" [showToggleAll]="false" [showClear]="false"
                        [showHeader]="true" [disabled]="false" placeholder="Choose a client" (onChange)="MultiSelectSingle_Toggle($event)">
                    </p-multiSelect>
                </div>
            </div>
        </div>

        <div class="glb_customFlexRow glb_paddingBottomXS">
            <!-- Generate Letter Button -->
            <div class="">
                <button [id]="'BTN_' + GenerateLetterButtonID" tabindex="19" class="glb_standardButton btn glb_BGColorSkin text-white col-12">
                    <span class="glb_Font glb_smallerText" (click)="GenerateLetter()">Generate Letter</span>
                </button>
            </div>
        </div>
    </div>

</div>